module.exports = __webpack_public_path__ + "img/planet-top-mobile.7612612.png";